export default {
  metadata: {
    version: '1.0.0',
    id: 'slider-1.0.0',
    name: 'JDSSlider',
    description:
      'Continuous Sliders allow the selection of a value within a given range.',
    usage:
      'Use Continuous Sliders whenever it makes easy for the user to select a value within a minimum and maximum range. Sliders work best when the specific value does not matter to the user, but an approximate value is good enough.'
  },
  hierarchy: {
    container: [
      {
        'top-container': [
          'label-jds-text',
          {
            'inner-container': ['value-jds-text', 'jds_input']
          }
        ]
      },
      'slider',
      {
        'bottom-container': ['min-jds-text', 'max-jds-text']
      },
      'jds_feedback_block',
      'helper-jds-text'
    ]
  },
  base: {
    container: {
      hidden: false,
      'flex-direction': '{s_0}',
      'justify-content': '{s_1}',
      'align-items': '{s_2}',
      width: '{s_3}',
      gap: '{s_4}'
    },
    'top-container': {
      hidden: false,
      'flex-direction': '{s_5}',
      'justify-content': '{s_6}',
      'align-items': '{s_7}',
      width: '{s_8}',
      gap: '{s_9}'
    },
    'inner-container': {
      hidden: false,
      height: 32,
      'align-items': '{s_12}',
      'padding-left': '{s_13}',
      'padding-right': '{s_14}',
      'border-width': '{s_15}',
      'border-color': '{s_16}',
      'border-radius': '{s_17}'
    },
    jds_input: {
      disabled: false,
      hidden: true,
      type: 'number',
      textAlign: 'end',
      rows: 1,
      width: 93
    },
    slider: {
      width: '{s_18}',
      'track-height': '{s_19}',
      'inactive-color': '{s_20}',
      'active-color': '{s_21}',
      'ball-size': 20,
      'ball-color': '{s_22}',
      'ball-border-color': '{s_23}',
      'ball-border-width': 0,
      'border-radius': '{s_24}',
      behavior: {
        hover: {
          'ball-color': '{s_25}'
        },
        active: {
          'active-color': '{s_26}',
          'ball-color': '{s_27}'
        },
        focus: {
          'ball-border-width': '{s_28}'
        }
      }
    },
    'bottom-container': {
      hidden: false,
      show: false,
      'flex-direction': '{s_29}',
      'justify-content': '{s_30}',
      'align-items': '{s_31}',
      width: '{s_32}'
    },
    jds_feedback_block: {
      size: 's',
      hidden: true
    },
    'label-jds-text': {
      'font-family': '{text_147}',
      color: '{text_21}',
      'font-size': '{text_146}',
      'line-height': '{text_148}',
      'letter-spacing': '{text_149}',
      'font-weight': '{text_150}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      hidden: false,
      flex: 1,
      'justify-content': '{s_10}',
      'align-items': '{s_11}',
      behavior: {
        hover: {
          color: '{text_20}'
        },
        focus: {
          color: '{text_20}'
        }
      }
    },
    'value-jds-text': {
      'font-family': '{text_132}',
      color: '{text_20}',
      'font-size': '{text_131}',
      'line-height': '{text_133}',
      'letter-spacing': '{text_134}',
      'font-weight': '{text_135}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      hidden: false
    },
    'min-jds-text': {
      'font-family': '{text_147}',
      color: '{text_21}',
      'font-size': '{text_146}',
      'line-height': '{text_148}',
      'letter-spacing': '{text_149}',
      'font-weight': '{text_150}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}'
    },
    'max-jds-text': {
      'font-family': '{text_147}',
      color: '{text_21}',
      'font-size': '{text_146}',
      'line-height': '{text_148}',
      'letter-spacing': '{text_149}',
      'font-weight': '{text_150}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}'
    },
    'helper-jds-text': {
      'font-family': '{text_147}',
      color: '{text_21}',
      'font-size': '{text_146}',
      'line-height': '{text_148}',
      'letter-spacing': '{text_149}',
      'font-weight': '{text_150}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      hidden: false
    }
  },
  variant: {
    _hideMinMaxLabel: {
      true: {
        'bottom-container': {
          hidden: true
        }
      }
    },
    editableTextBox: {
      true: {
        jds_input: {
          hidden: false
        },
        'value-jds-text': {
          hidden: true
        }
      }
    },
    state: {
      success: {
        'inner-container': {
          'border-color': '{s_33}'
        },
        jds_feedback_block: {
          hidden: false
        }
      },
      error: {
        'inner-container': {
          'border-color': '{s_34}'
        },
        jds_feedback_block: {
          hidden: false
        }
      },
      warning: {
        'inner-container': {
          'border-color': '{s_35}'
        },
        jds_feedback_block: {
          hidden: false
        }
      }
    },
    disabled: {
      true: {
        container: {
          disabled: true,
          opacity: '{s_36}'
        },
        jds_input: {
          disabled: true
        },
        slider: {
          disabled: true,
          behavior: {
            hover: {
              'ball-color': '{s_37}'
            },
            active: {
              'active-color': '{s_38}',
              'ball-color': '{s_39}'
            },
            focus: {
              'ball-border-width': 0
            }
          }
        }
      }
    }
  },
  combination: [{}],
  combination_config: [[]],
  api: {
    config: {
      _hideMinMaxLabel: {
        values: [false, true]
      },
      editableTextBox: {
        values: [false, true],
        doc_description:
          ' It allows user to input their own number in the text box that moves the slider value. By default this textbox is in readonly mode.'
      },
      state: {
        type: 'JDSFeedbackBlock.state',
        doc_description:
          "It can be used to choose between states i.e. 'success','warning','error','none'.",
        values: ['none', 'success', 'error', 'warning']
      },
      disabled: {
        values: [false, true],
        doc_description: 'It can be used to enable or disable SearchBox.'
      }
    },
    data: {
      jds_input: {
        id: {
          type: 'string',
          name: 'id'
        },
        name: {
          type: 'string',
          name: 'name'
        },
        value: {
          type: 'string',
          name: 'valueSuffix',
          function: true
        },
        placeholder: {
          type: 'string',
          name: 'placeholder'
        },
        min: {
          type: 'float',
          name: 'min',
          function: true,
          doc_description: 'It is minimum value for Slider.'
        },
        max: {
          type: 'float',
          name: 'max',
          function: true,
          doc_description: 'It is maximum value for Slider.'
        },
        required: {
          type: 'boolean',
          name: 'required'
        }
      },
      slider: {
        step: {
          type: 'number',
          name: 'step',
          doc_description:
            'It determines number of divisions slider should slide by.'
        },
        min: {
          type: 'float',
          name: 'min',
          function: true,
          doc_description: 'It is minimum value for Slider.'
        },
        max: {
          type: 'float',
          name: 'max',
          function: true,
          doc_description: 'It is maximum value for Slider.'
        },
        value: {
          type: 'float',
          name: 'value',
          function: true,
          doc_description: 'It takes user input for value of Slider.'
        },
        required: {
          type: 'boolean',
          name: 'required'
        }
      },
      jds_feedback_block: {
        stateText: {
          type: 'string',
          name: 'stateText',
          doc_description:
            'It displays message with respect to its [state] selected.'
        },
        state: {
          type: 'JDSFeedbackBlock.state',
          name: 'state'
        }
      },
      'label-jds-text': {
        value: {
          type: 'string',
          name: 'label',
          doc_description: 'It displays label of Slider.'
        }
      },
      'value-jds-text': {
        value: {
          type: 'string',
          name: 'valueSuffix',
          function: true
        }
      },
      'min-jds-text': {
        value: {
          type: 'string',
          name: 'labelMin'
        }
      },
      'max-jds-text': {
        value: {
          type: 'string',
          name: 'labelMax'
        }
      },
      'helper-jds-text': {
        value: {
          type: 'string',
          name: 'helperText',
          doc_description: 'It displays helper text of Slider.'
        }
      }
    },
    events: {
      slider: {
        onChange: 'onValueChange'
      },
      jds_input: {
        onFocus: 'onFocus',
        onBlur: 'onBlur',
        onChange: 'onChange',
        onSubmit: 'onSubmit',
        onKeydown: {
          name: 'onKeydown',
          platform: 'web'
        }
      }
    },
    a11y: {
      slider: {
        name: 'container',
        properties: {
          role: {
            value: 'slider'
          },
          'aria-label': {
            name: 'ariaLabel',
            prop: 'label',
            function: true
          },
          'aria-describedby': {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          },
          'aria-valuenow': {
            name: '_ariaValuenow',
            prop: 'value',
            platform: 'web,ios'
          },
          'aria-valuemin': {
            name: '_ariaValuemin',
            prop: 'min',
            platform: 'web,ios'
          },
          'aria-valuemax': {
            name: '_ariaValuemax',
            prop: 'max',
            platform: 'web,ios'
          }
        }
      }
    }
  }
};
